import React, { useState } from 'react';
import { Form, Button, Card, Container, Alert, Spinner } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import Logo from '../assets/logo.png';

const ForgetPassword = () => {
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [step, setStep] = useState(1); // 1: Email Input, 2: OTP & New Password
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;

    // Step 1: User ko OTP bhejna
    const handleSendOTP = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            // Wahi FastAPI endpoint jo registration mein use kiya tha
            await axios.post(`${API_URL}/send-otp`, { email });
            setStep(2);
            setLoading(false);
        } catch (err) {
            setError(err.response?.data?.detail || "Email not found or failed to send OTP.");
            setLoading(false);
        }
    };

    // Step 2: OTP verify karke password reset karna
    const handleResetPassword = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            // FastAPI endpoint jo OTP aur naya password verify karega
            await axios.post(`${API_URL}/reset-password-verify`, { 
                email, 
                otp, 
                new_password: newPassword 
            });
            setSuccess("Password updated successfully! Redirecting to login...");
            setLoading(false);
            setTimeout(() => navigate('/login'), 2000);
        } catch (err) {
            setError(err.response?.data?.detail || "Invalid OTP or expired. Please try again.");
            setLoading(false);
        }
    };

    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
            <Card style={{ width: '400px' }} className="shadow-lg border-0 rounded-4">
                <Card.Body className="p-4">
                    <div className="text-center mb-4">
                        <img src={Logo} alt='Logo' className='rounded-circle mb-3' style={{width: '60px', height: '60px'}} />
                        <h3 className="fw-bold">Forget Password?</h3>
                        <p className="text-muted small">
                            {step === 1 
                                ? "Enter your registered email to get OTP" 
                                : `Enter the 6-digit code sent to ${email}`}
                        </p>
                    </div>

                    {error && <Alert variant="danger" className="py-2 small">{error}</Alert>}
                    {success && <Alert variant="success" className="py-2 small">{success}</Alert>}

                    {step === 1 ? (
                        // --- STEP 1: Email Input ---
                        <Form onSubmit={handleSendOTP}>
                            <Form.Group className="mb-4">
                                <Form.Label className="small fw-bold">Email Address</Form.Label>
                                <Form.Control 
                                    type="email" 
                                    placeholder="name@example.com" 
                                    required 
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)} 
                                />
                            </Form.Group>

                            <Button variant="primary" className="w-100 py-2 fw-bold shadow-sm rounded-pill" type="submit" disabled={loading}>
                                {loading ? <Spinner animation="border" size="sm" /> : "Send Reset OTP"}
                            </Button>
                        </Form>
                    ) : (
                        // --- STEP 2: OTP & New Password ---
                        <Form onSubmit={handleResetPassword}>
                            <Form.Group className="mb-3">
                                <Form.Label className="small fw-bold">OTP Code</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    placeholder="Enter 6-digit OTP" 
                                    maxLength="6"
                                    required 
                                    className="text-center fw-bold"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)} 
                                />
                            </Form.Group>

                            <Form.Group className="mb-4">
                                <Form.Label className="small fw-bold">New Password</Form.Label>
                                <Form.Control 
                                    type="password" 
                                    placeholder="Enter new password" 
                                    required 
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)} 
                                />
                            </Form.Group>

                            <Button variant="success" className="w-100 py-2 fw-bold shadow-sm rounded-pill mb-3" type="submit" disabled={loading}>
                                {loading ? <Spinner animation="border" size="sm" /> : "Reset Password"}
                            </Button>

                            <div className="text-center">
                                <Button variant="link" className="small text-decoration-none p-0" onClick={() => setStep(1)}>
                                    Change Email
                                </Button>
                            </div>
                        </Form>
                    )}
                    
                    <div className="text-center mt-3">
                        <small>Remember your password? <Link to="/login">Login here</Link></small>
                    </div>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default ForgetPassword;